module.exports = __webpack_public_path__ + "img/fig29.365f1597.jpg";